import createCrudModule from 'vuex-crud';
import {client, parseResponse} from '@/api'

export default createCrudModule({
  resource: 'sliders',
  client,
  parseSingle: parseResponse,
  parseList: parseResponse
});
